import { Box, SxProps, Typography } from "@mui/material";
import Image from "./Image";
import { ReactService } from "../../services/react.service";
import React, { ReactNode } from "react";
import { VoidFunction } from "../../models/common.models";

interface IconTextProps {
  children?: ReactNode;
  iconSrc?: string;
  text: string;
  iconSx?: React.CSSProperties;
  textSx?: SxProps;
  containerSx?: SxProps;
  innerContainerSx?: SxProps;
  gap?: string;
  onClick?: VoidFunction;
}

enum IconTextSlots {
  BEFORE = "before",
  AFTER = "after",
}

const IconText = ({
  children,
  innerContainerSx,
  iconSrc,
  text,
  textSx,
  iconSx,
  gap = "8px",
  containerSx,
  onClick,
}: IconTextProps) => {
  const childrenArray = React.Children.toArray(children);
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap,
        ...containerSx,
      }}
    >
      {children && ReactService.renderSlot(childrenArray, IconTextSlots.BEFORE)}
      <Box
        sx={{ display: "flex", alignItems: "center", gap, ...innerContainerSx }}
      >
        {iconSrc && <Image sx={iconSx} src={iconSrc} />}
        <Typography sx={textSx}>{text}</Typography>
      </Box>
      {children && ReactService.renderSlot(childrenArray, IconTextSlots.AFTER)}
    </Box>
  );
};

export default IconText;
